"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LastUpdated = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const LastUpdateText = (0, styled_components_1.default)(base_react_components_1.Copy).attrs(() => ({ light: true, size: 'xs' })).withConfig({ displayName: "reports-LastUpdateText", componentId: "reports-1bw5cie" }) ``;
const LastUpdated = ({ date }) => {
    const dateEpoch = new Date(date).getTime();
    if (isNaN(dateEpoch)) {
        return react_1.default.createElement(LastUpdateText, null, "Last Updated 0 Days Ago");
    }
    const ms = new Date().getTime() - dateEpoch;
    const days = Math.floor(ms / 1000 / 60 / 60 / 24);
    const unit = days > 1 || days === 0 ? 'Days' : 'Day';
    return react_1.default.createElement(LastUpdateText, null,
        "Last updated ",
        `${days} ${unit}`,
        " ago");
};
exports.LastUpdated = LastUpdated;
exports.default = (0, styled_components_1.default)(exports.LastUpdated).withConfig({ componentId: "reports-161kj9z" }) ``;
//# sourceMappingURL=index.js.map